import { render, staticRenderFns } from "./LinksList.vue?vue&type=template&id=b54799c8&scoped=true"
import script from "./LinksList.vue?vue&type=script&lang=js"
export * from "./LinksList.vue?vue&type=script&lang=js"
import style0 from "./LinksList.vue?vue&type=style&index=0&id=b54799c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54799c8",
  null
  
)

export default component.exports